import React, { memo } from 'react'
import { useBackToTop, BackToTopProps } from './useBackToTop'
import styles from './BackToTop.module.scss'

const BackToTop: React.FC<BackToTopProps> = (props: BackToTopProps) => {
  const { isActive } = useBackToTop(props)

  return (
    <a
      href='#'
      id='scroll-top'
      className={`${
        styles['scroll-top']
      } d-flex align-items-center justify-content-center ${
        isActive ? styles.active : ''
      }`}
    >
      <i className='bi bi-arrow-up-short'></i>
    </a>
  )
}

export default memo(BackToTop)
